import { JoinServiceBase } from '../../shared/base/join-service-base';
import { ListObservable } from '../../shared/base/list-observable';

export class OrderedJoinServiceBase extends JoinServiceBase {
  readList(key: string, fieldName?: string): ListObservable<any> {
    return super.readList(key, fieldName, {
      query: {
        orderByChild: 'order'
      }
    });
  }

  readRecentList(key: string, length: number, fieldName?: string): ListObservable<any> {
    return super.readList(key, fieldName, {
      query: {
        limitToLast: length
      }
    });
  }

  addRef(key: string, refKey: string) {
    return this.readRef(key, refKey).set({
      order: this.count(key)
    });
  }

  count(key: string): number {
    let count = 0;
    this.readChild(key).$ref.on('value', function(snapshot) {
      count = snapshot.numChildren();
    });
    return count;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/ordered-join-service-base.ts